<div class="row">
  <div class="col-12 col-md-8">
    <nb-card accent="primary" size="tiny">
      <nb-card-header class="d-flex">
        <span class="mr-auto">{{ "create_app" | translate }}</span>
        <nb-icon
          icon="question-mark-circle-outline"
          [nbPopover]="helpAppCreation"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </nb-card-header>

      <nb-card-body *ngIf="contract.limits" class="d-flex align-items-center">
        <nb-actions size="medium">
          <nb-action
            *ngFor="let appId of contract.limits.allowedPlatformIds"
            class="create-action"
          >
            <ng-container *ngIf="env.platformconfigs[appId]">
              <a
                [routerLink]="['new', { template: appId }]"
                class="text-center"
                title="{{ 'create' | translate }} {{
                  env.platformconfigs[appId].name
                }} app"
              >
                <img
                  id="1"
                  width="36"
                  height="36"
                  alt="{{ env.platformconfigs[appId].name }}"
                  src="assets/images/brands/{{
                    env.platformconfigs[appId].icon
                  }}"
                />
                <div>{{ env.platformconfigs[appId].name }}</div>
              </a>
            </ng-container>
          </nb-action>
        </nb-actions>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-12 col-md-4">
    <nb-card accent="primary" size="tiny">
      <nb-card-header class="d-flex">
        <span class="mr-auto">{{ "information" | translate }}</span>
        <nb-icon
          icon="question-mark-circle-outline"
          [nbPopover]="helpInformation"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </nb-card-header>

      <nb-card-body>
        <div>{{ "contract" | translate }}: {{ contract.plan }}</div>
        <div>Apps: {{ $count | async }} / {{ contract?.limits?.apps }}</div>
        <div>
          {{ "platforms" | translate }}:
          {{ contract?.limits?.allowedPlatformIds?.length }}
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <nb-card accent="primary">
      <nb-card-header class="d-flex align-items-center">
        <span class="mr-auto">{{ "administration_app" | translate }}</span>
        <div class="w-25 pr-0 d-flex justify-content-end">
          <input
            nbInput
            #searchInput
            fullWidth
            type="text"
            placeholder="{{ 'search' | translate }}"
            (keyup)="updateFilter($event)"
          />
        </div>
      </nb-card-header>

      <nb-card-body>
        <ngx-datatable
          class="ngx-datatable bootstrap"
          headerHeight="auto"
          rowHeight="auto"
          [columnMode]="'force'"
          [rows]="$data | async"
          [columns]="columns"
          [reorderable]="true"
          [sorts]="[{ prop: 'id', dir: 'desc' }]"
          (activate)="$event.type === 'click' && $event.cellElement.blur()"
        >
        </ngx-datatable>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- TableColumns Header -->
<ng-template #nameHdrTpl let-column="column">
  {{ column.prop | translate }}
</ng-template>

<!-- Columns-->

<ng-template #typeTemplate let-row="row">
  <img
    *ngIf="env.platformconfigs[row.platformId]"
    width="23"
    height="23"
    title="{{ env.platformconfigs[row.platformId].name }}"
    alt="{{ env.platformconfigs[row.platformId].name }}"
    src="assets/images/brands/{{ env.platformconfigs[row.platformId].icon }}"
  />
</ng-template>

<ng-template
  #buttonsTemplate
  let-row="row"
  let-value="value"
  let-button="column.actions"
>
  <nb-icon
    class="action-icon"
    [routerLink]="row.id + '/info'"
    icon="info-outline"
    status="basic"
    title="{{ 'info' | translate }} {{ row.name }}"
  ></nb-icon>
  <nb-icon
    class="action-icon"
    [routerLink]="row.id"
    icon="edit-outline"
    status="basic"
    title="{{ 'edit' | translate }} {{ row.name }}"
  ></nb-icon>
  <nb-icon
    class="action-icon"
    (click)="handleClickDelete(row)"
    icon="trash-2-outline"
    status="basic"
    title="{{ 'delete' | translate }} {{ row.name }}"
  ></nb-icon>
  <nb-icon
    class="action-icon"
    (click)="handleClickTagAssign(row)"
    icon="pricetags-outline"
    status="basic"
    title="{{ 'assign_tag' | translate }} {{ row.name }}"
  ></nb-icon>
</ng-template>

<ng-template #tagsTemplate let-row="row" let-value="value">
  <div class="tag-overflow">
    <span class="tag-names">{{ value[0] }}</span>
    <div class="{{ value[1] !== 0 ? 'tag-amount' : 'tag-amount no-tags' }}">
      {{ value[1] }}
    </div>
  </div>
</ng-template>

<ng-template #tagGroupsTemplate let-row="row" let-value="value">
  <div class="tag-overflow">
    <span class="tag-names">{{ value[0] }}</span>
    <div class="{{ value[1] !== 0 ? 'tag-amount' : 'tag-amount hidden' }}">
      {{ value[1] }}
    </div>
  </div>
</ng-template>

<!-- Modals-->

<ng-template #deleteDialog let-context let-ref="dialogRef">
  <nb-card accent="primary">
    <nb-card-header>{{ "delete" | translate }}</nb-card-header>
    <nb-card-body
      >{{ "delete_question" | translate }}:
      <strong>{{ context.app.name }}</strong></nb-card-body
    >
    <nb-card-footer class="d-flex">
      <button nbButton (click)="ref.close()" class="mr-auto">
        {{ "close" | translate }}
      </button>
      <button nbButton (click)="context.delete(); ref.close()">
        {{ "delete_app" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #tagAssignDialog let-context let-ref="dialogRef">
  <nb-card>
    <nb-card-header>{{ "assign_tag" | translate }}</nb-card-header>
    <nb-card-body>
      <app-tag-select
        [selected]="context.selectedTags"
        (changes)="context.changes = $event"
      >
      </app-tag-select>
    </nb-card-body>
    <nb-card-footer class="d-flex">
      <button nbButton (click)="ref.close()" class="mr-auto">
        {{ "close" | translate }}
      </button>
      <button nbButton (click)="context.assign(context.changes); ref.close()">
        {{ "assign_tag" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- HELP TEXT -->

<ng-template #helpAppCreation>
  <div
    class="primitive-overlay"
    [innerHTML]="'help_app_create' | translate"
  ></div>
</ng-template>

<ng-template #helpInformation>
  <div
    class="primitive-overlay"
    [innerHTML]="'help_app_information' | translate"
  ></div>
</ng-template>
